/**
 * TutorialContent component - preserved public API for tutorial pages.
 * Internally delegates to the shared `MarkdownContent` renderer.
 */

import { MarkdownContent } from "#app/components/markdown/MarkdownContent";
import { type MockData } from "#app/lib/tutorials/parser";

export interface TutorialContentProps {
  content: string;
  mocks?: MockData[];
  onCheckpointComplete?: (id: string, correct: boolean) => void;
  completedCheckpoints?: string[];
  className?: string;
}

export function TutorialContent({
  content,
  mocks = [],
  onCheckpointComplete: _onCheckpointComplete,
  completedCheckpoints = [],
  className,
}: TutorialContentProps) {
  return (
    <MarkdownContent
      content={content}
      mocks={mocks}
      completedCheckpoints={completedCheckpoints}
      className={className}
    />
  );
}
